import React, { useContext, useEffect, useState } from "react";
import SavedProductContext from "../SavedProductsContext";
import { addProduct } from "../services/ProductsService";
import { updateSavedProducts } from "../utils/SavedProductsLocal";

import {
  Button,
  Input,
  FormControl,
  FormLabel,
  NumberInput,
  NumberInputField,
  useToast,
} from "@chakra-ui/react";

export const AddProductModalForm = ({ productBarcode }) => {
  const [newProduct, setNewProduct] = useState({});
  const [products, setProducts, productsQty, setProductsQty] = useContext(
    SavedProductContext
  );
  const toast = useToast();

  useEffect(() => {
    setNewProduct({ barcode: productBarcode, salePrice: 100 });
    console.log("halting");
  }, [productBarcode]);

  const handleSubmit = async () => {
    const response = await addProduct(newProduct);
    const responseData = response.data;
    if (response.data["msg"] !== "success") {
      // Handle unsuccessful request
      toast({
        title: "Error",
        description: `Hubo un error al crear ${newProduct.description}`,
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    } else {
      setProducts({ ...products, [responseData.id]: responseData });
      setProductsQty({
        ...productsQty,
        [responseData.id]: productsQty[responseData.id]
          ? productsQty[responseData.id] + 1
          : 1,
      });
      updateSavedProducts(responseData);
      toast({
        title: "Producto creado y agregado",
        description: `Se creó el producto ${newProduct.description}`,
        status: "success",
        duration: 9000,
        isClosable: true,
      });

    }
  };
  return (
    <>
      <FormControl>
        <FormLabel>Código del producto</FormLabel>
        <Input
          value={newProduct.barcode}
          placeholder="Código del producto"
          onChange={(e) => setNewProduct({ barcode: e.target.value })}
        />
      </FormControl>
      <FormControl>
        <FormLabel>Nombre del producto</FormLabel>
        <Input
          onChange={(e) =>
            setNewProduct({ ...newProduct, description: e.target.value })
          }
          placeholder="Nombre"
        />
      </FormControl>
      <FormControl>
        <FormLabel>Precio venta</FormLabel>
        <NumberInput defaultValue={100} precision={2}>
          <NumberInputField
            onChange={(e) =>
              setNewProduct({ ...newProduct, salePrice: e.target.value })
            }
          />
        </NumberInput>
      </FormControl>
      <Button onClick={handleSubmit}>Agregar producto</Button>
    </>
  );
};
